import { config } from 'boot/config.js'
import qs from 'qs'
import { currentHost, currentURL } from 'src/utils/uri.js'
import { ref } from 'vue'


const loggingIn = ref(false)
const loggingOut = ref(false)

/**
 * @param {string|null} targetUrl
 * @param {string[]|null} identityProviders
 */
function login(targetUrl, identityProviders = null) {
  if(identityProviders !== null && !Array.isArray(identityProviders)) {
    throw new Error('identityProviders must be an array of strings, or null.')
  }

  window.location.assign(config.urls.api + '/login?' + qs.stringify({
    targetUrl: targetUrl || currentURL(),
    branding: config.theme.branding,
    identityProviders
  }))
}

function logout() {
  window.location.assign(config.urls.api + '/logout?' + qs.stringify({
    targetUrl: currentHost(),
    branding: config.theme.branding
  }))
}

/**
 * Use useAuth.js instead
 * @internal
 */
export const auth = {
  loggingIn,
  loggingOut,
  login,
  logout
}
